import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataLegalEntityUserRolesState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataLegalEntityUserRolesReducer.legalEntityUserRolesFeatureKey]
);

export const getStaticDataLegalEntityUserRolesFailure = createSelector(
  getStaticDataLegalEntityUserRolesState,
  staticDataCountriesReducer.fromStaticDataLegalEntityUserRolesReducer.getLegalEntityUserRolesFailure
);

export const getStaticDataLegalEntityUserRolesResponse = createSelector(
  getStaticDataLegalEntityUserRolesState,
  staticDataCountriesReducer.fromStaticDataLegalEntityUserRolesReducer.getLegalEntityUserRolesResponse
);

export const getStaticDataLegalEntityUserRolesisLoaded = createSelector(
  getStaticDataLegalEntityUserRolesState,
  staticDataCountriesReducer.fromStaticDataLegalEntityUserRolesReducer.getLegalEntityUserRolesIsLoaded
);
